module.exports = __webpack_public_path__ + "static/media/step4.bc530e10.png";